import { connect } from 'react-redux';
import Global from '../../store/global-selectors';
import AssignToButton from '../../components/grid-header/assign-to-button';
import * as Actions from '../../store/orders/orders.actions';
import { getActualFulfillmentPlanIds } from '../../store/orders/orders.helpers';
import { emptyArray } from 'ui-components/default-props/empty';

const mapStateToProps = (state) => {
  const users = Global.selectSellerUsersSortedByName(state) || emptyArray;
  const selectedOrderIds = Global.selectSelectedOrdersIds(state) || emptyArray;
  const actualFulfillmentPlanIds = getActualFulfillmentPlanIds(state, selectedOrderIds);
  return {
    users,
    selectedIds: actualFulfillmentPlanIds,
    isDisabled: !actualFulfillmentPlanIds.length,
    supportsUnassignedOption: true,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAssign: (selectedIds, userId) => {
      dispatch(Actions.assignBulkFulfillmentPlanToUserFromOrdersGrid(selectedIds, userId));
    },
  };
};

export const AssignToOrders = connect(mapStateToProps, mapDispatchToProps)(AssignToButton);
